export default __webpack_public_path__ + "static/media/cocobay.eb8b6760.png";